import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { assignHighlight, showOffer, toggleFormOffer } from '../../../../../redux/actions/offers'
import { IRootState } from '../../../../../redux/types'

export const useOfferTable = () => {
  const dispatch = useDispatch()
  const offerState = useSelector((state: IRootState) => state.offer)
  const [openDeleteOffer, setOpenDeleteOffer] = useState(false)
  const [offerSelected, setOfferSelected] = useState<number | false>(false)

  const handleClickHighlight = (id: number, isHighlight: boolean) => {
    dispatch(assignHighlight({ id, isHighlight }))
  }

  const handleEdditOffers = (id: number) => {
    dispatch(showOffer(id))
    dispatch(toggleFormOffer())
  }

  const handleDeleteOffers = (id: number) => {
    setOpenDeleteOffer(!openDeleteOffer)
    setOfferSelected(id)
  }

  return {
    handleEdditOffers,
    handleDeleteOffers,
    handleClickHighlight,
    setOfferSelected,
    setOpenDeleteOffer,
    openDeleteOffer,
    offerSelected,
    offerState
  }
}
